<script setup>
import PrematchSportsNavigation from '@/components/PrematchSportsNavigation.vue';
import Carousel from '@/components/App/Carousel.vue';
import MainEventCard from './Partials/MainEventCard.vue';
import Spinner from '@/components/Spinner.vue';
import MainLeagues from './Partials/MainLeagues.vue';
import FunPlayModal from './Partials/FunPlayModal.vue';
import JackpotCards from '@/components/JackpotCards.vue';
import JackpotBells from '@/components/JackpotBells.vue';
import JackpotClover from '@/components/JackpotClover.vue';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref , watch} from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useGamesStore } from '@/stores/games';
import { useRouter } from 'vue-router';
import { useFixturesStore } from '@/stores/fixtures';
import { useI18n } from 'vue-i18n';

const { t, te } = useI18n()
const auth = useAuthStore()
const games = useGamesStore()
const fixtures = useFixturesStore()
const assetsUrl = import.meta.env.VITE_ASSETS_URL

const { getCredits, getCurrency, getUser, isAuth } = storeToRefs(auth)
const { getRecents , getNewGames, getGame, getLCRecents, getNewLCGames, getGames} = storeToRefs(games)
const { getMainFixtures } = storeToRefs(fixtures)
const router = useRouter()
const opening = ref(false)
const selectedGame = ref(null)
const modalRef = ref(null)
const casinoItems = [
  { key: "spor",    icon: "/casino/3.webp", label: "SPORT", link:"/sports" },
  { key: "zep",     icon: "/casino/4.webp", label: "LIVE SPORT", link:"/in-play" },
  { key: "slot",    icon: "/casino/2.webp", label: "SLOT", link:"/casino" },
  { key: "casino",  icon: "/casino/1.webp", label: "CASINO", link:"/live-casino" },
  { key: "virtual",   icon: "/casino/7.webp", label: "VIRTUAL", link:"/casino/provider/68907fc68108ac37decc7c63" },
//   { key: "tvbet",   icon: "/casino/5.webp", label: "TV BET", link:"/casino" },
  { key: "aviator", icon: "/casino/8.webp", label: "AVIATOR", link:"/casino/provider/6978e4ae85fd075925db0638" }
]
onMounted(() => {
   fixtures.fetchMainCompetitions()
   fixtures.fetchMainFixtures()
    // if(isAuth.value){
    //     games.fetchRecentsGames() 
    // }
})

const filteredGames = computed(() => {
//   const recents = getRecents.value;
//   if (recents.length >= 10) {
//     return recents.slice(0, 10);
//   }
//   const needed = 10 - recents.length;
  const needed = 10;
  const extras = getNewGames.value.slice(0, needed);
//   return [...recents, ...extras];
  return [...extras];
});


const filteredLCGames= computed(() => {
//   const recents = getLCRecents.value;
//   if (recents.length >= 6) {
//     return recents.slice(0, 6);
//   }
//   const needed = 6 - recents.length;
  const needed = 6;
  const extras = getNewLCGames.value.slice(0, needed);
//   return [...recents, ...extras];
  return [...extras];
});
const lang = ref(localStorage.getItem('lang') || 'en')

const openGame = (game) => {
    if(isAuth.value){
        if (game.has_demo === 'Y' && getUser.value?.c_p_demo) {
            selectedGame.value = game
            modalRef.value.openModal()
        } else {
            launchGame(game, false)
        }
    }else{
         router.push({ name: 'login' })
    }

}
const launchGame = async (game, isDemo) => {
  opening.value = true;

  try {
    const res = await games.openGame(game._id, {
      device: 'M',
      currency_id: getCredits.value[0].cuid._id,
      currency_name: getCurrency.value(getCredits.value[0].cuid._id).cod,
      homeURL: import.meta.env.VITE_APP_URL,
      demo: isDemo,
      lang: lang.value
    });

    opening.value = false;

    if (res.data?.nt === true) {
      window.open(res.data.data, '_blank');
      return;
    }

    if (res.data?.nt === false) {
      games.setGameUrl(res.data.data);
      router.push('/casino/game');
    }

  } catch (error) {
    opening.value = false;
    console.error(error);
  }
};


const handlePlay = ({ demo }) => {
    launchGame(selectedGame.value, demo)
}

const sliderImages = [
    { src: '/banner/1.png', url: '/casino/provider/67584aa2792b47680fe03982' },
    { src: '/banner/2.png', url: '/casino/provider/67584aa2792b47680fe03982' },
    { src: '/banner/3.png', url: '/live-casino' },
    { src: '/banner/4.png', url: '/sports' },
    { src: '/banner/5.png', url: '/casino/provider/6978e4ae85fd075925db0638' },
]
const goTo = (casinoLink) => {
  router.push(casinoLink);
};
const jackpotTabs = [
  { id: 'belllink', label: t('jackpots.bell_link') },
  { id: 'cloverchance', label: t('jackpots.clover') },
  { id: 'amusnet', label: t('jackpots.amusnet') },
]
const activeJackpotTab = ref('belllink')
const setJackpotTab = (id) => { activeJackpotTab.value = id }

</script>

<template>
      <div class="xl:flex flex-1 overflow-hidden">
        <div class="flex-1 w-full">
            <div class="pt-1.5 px-3">
                <Carousel
                    height="250px"
                    :items="sliderImages"
                    :slidesPerView="1"
                    :spaceBetween="20"
                    :showNavigation="false"
                    :showPagination="true"
                    :autoplay="{ delay: 1500, disableOnInteraction: false }"
                    :swiperOptions="{ loop: true }"
                >
                    <template #slide="{ slide }">
                        <RouterLink :to="slide.url" class="block w-full h-full">
                            <img :src="slide.src" alt="" class="carousel-img rounded-lg cursor-pointer"/>
                        </RouterLink>
                    </template>
                </Carousel>
            </div>
            <div class="px-3 my-3 grid gap-4 w-full [grid-template-columns:repeat(auto-fill,minmax(96px,1fr))]">
                <button 
                    v-for="item in casinoItems" :key="item.key" 
                    class="jpNavCard" 
                    type="button"
                    @click="goTo(item.link)"
                >
                    <img class="jpNavCard__icon" :src="item.icon" alt="" />
                    <div class="jpNavCard__label">{{ item.label }}</div>
                </button>
            </div>
            <PrematchSportsNavigation class="py-2.5 px-3"/>    
            <div class="px-3" v-if="getMainFixtures(1).length">
                <Carousel
                    height="250px"
                    :items="getMainFixtures(1)"
                    :slidesPerView="1"
                    :spaceBetween="20"
                    :showNavigation="true"
                    :showPagination="true"
                    :autoplay="false"
                    :swiperOptions="{ loop: true }"
                >
                    <template #slide="{ slide }">
                        <MainEventCard :event="slide" />
                    </template>
                </Carousel>
            </div>
              <div class="casino-jackpot-tabs">
                <ul class="casino-jackpot-tabs__list">
                    <li
                        v-for="tab in jackpotTabs"
                        :key="tab.id"
                        @click="setJackpotTab(tab.id)"
                        :class="['casino-jackpot-tabs__pill', activeJackpotTab === tab.id && 'casino-jackpot-tabs__pill--active']"
                    >
                        <span>{{ tab.label }}</span>
                    </li>
                </ul>
            </div>
            <div v-show="activeJackpotTab === 'belllink'">
            <JackpotBells
                :card1="1504252.84"
                :card1-middle="951252.85"
                :card1-start="651251.98"

                :card2="99582.78"
                :card2-middle="85255.45"
                :card2-start="65244.25"

                :card3="3528.52"
                :card3-middle="2552.25"
                :card3-start="1125.12"

                :card4="724.01"
                :card4-middle="521.50"
                :card4-start="212.01"

                :seconds-per-unit="0.1"
                currency-code="TRY"
            />
            </div>
            <div v-show="activeJackpotTab === 'cloverchance'">
                <JackpotClover
                    :card1="1524252.84"
                    :card1-middle="1221252.85"
                    :card1-start="951251.98"

                    :card2="109582.78"
                    :card2-middle="95255.45"
                    :card2-start="85244.25"

                    :card3="7528.52"
                    :card3-middle="5552.25"
                    :card3-start="3125.12"

                    :card4="2124.01"
                    :card4-middle="1521.50"
                    :card4-start="1112.01"

                    :seconds-per-unit="0.1"
                    currency-code="TRY"
                />
                </div>
                <div v-show="activeJackpotTab === 'amusnet'">
                    <JackpotCards
                    :card1="624252.84"
                    :card1-middle="521252.85"
                    :card1-start="352251.98"

                    :card2="99582.78"
                    :card2-middle="94255.45"
                    :card2-start="85244.25"

                    :card3="15528.52"
                    :card3-middle="12552.25"
                    :card3-start="5125.12"

                    :card4="1524.01"
                    :card4-middle="1321.50"
                    :card4-start="612.01"

                    :seconds-per-unit="0.1"
                    currency-code="TRY"
                />
            </div>
            <div class="px-3 pb-4 block" v-if="filteredGames.length">
                <div class="flex items-center justify-between pb-2">
                    <p class="flex items-center gap-1 font-futura text-lg text-[var(--color-primary4)] uppercase font-bold">
                        <div class="star-icn" />
                        {{ $t('app.35') }}
                    </p>
                    <RouterLink 
                        :to="`/casino`"  
                        class="show-btn" 
                    >
                        <span>{{  $t('app.36') }}</span>
                        <div class="mgc-Chevron " />
                    </RouterLink>
                </div>
                <div class="relative">
                    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-2">
                        <div v-for="item in filteredGames">
                            <img 
                                @click="openGame(item)"
                                v-img-fallback="[`${assetsUrl}/c/g/old/${item.img}`, `${assetsUrl}/c/g/${item.img}`, item.extimg]"              
                                class="h-auto w-full rounded-lg"
                                alt=""
                                loading="lazy"
                            >
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="px-3 pb-4 block" v-if="getGames('675839454f20898d9b11dde5', '6978e51185fd075925db069d').length">
                <div class="flex items-center justify-between pb-2">
                    <p class="flex items-center gap-1 font-futura text-lg text-[var(--color-primary4)] uppercase font-bold">
                        <div class="star-icn" />
                        {{ $t('games.fast') }}
                    </p>
                    <RouterLink 
                        :to="`/casino`"  
                        class="show-btn" 
                    >
                        <span>{{  $t('app.36') }}</span>
                        <div class="mgc-Chevron " />
                    </RouterLink>
                </div>
                <div class="relative">
                    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-2">
                        <div v-for="item in getGames('675839454f20898d9b11dde5', '6978e51185fd075925db069d')">
                            <img 
                                @click="openGame(item)"
                                v-img-fallback="[`${assetsUrl}/c/g/old/${item.img}`, `${assetsUrl}/c/g/${item.img}`, item.extimg]"              
                                class="h-auto w-full rounded-lg"
                                alt=""
                                loading="lazy"
                            >
                        </div>
                    </div>
                </div>
            </div>
             <div class="px-3 pb-4 block" v-if="filteredLCGames.length">
                <div class="flex items-center justify-between pb-2">
                    <p class="flex items-center gap-1 font-futura text-lg text-[var(--color-primary4)] uppercase font-bold">
                        <div class="star-icn" />
                        {{ $t('app.43') }}
                    </p>
                    <RouterLink 
                        :to="`/live-casino`"  
                        class="show-btn" 
                    >
                        <span>{{  $t('app.36') }}</span>
                        <div class="mgc-Chevron " />
                    </RouterLink>
                </div>
                <div class="relative">
                    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-2">
                        <div v-for="item in filteredLCGames">
                            <img 
                                @click="openGame(item)"
                                v-img-fallback="[`${assetsUrl}/c/g/old/${item.img}`, `${assetsUrl}/c/g/${item.img}`, item.extimg]"   
                                class="h-auto w-full rounded-lg"
                                alt=""
                                loading="lazy"
                            >
                        </div>
                    </div>
                </div>
            </div>
            <MainLeagues />
        </div>
        <FunPlayModal
            ref="modalRef"
            :value="selectedGame"
            @play="handlePlay"
        />
        <Spinner :show="opening" />
    </div>
</template>

<style scoped>
.show-btn {
    @apply text-center flex items-center justify-center gap-1 text-[var(--color-primary4)] hover:text-[var(--color-primary4)] text-sm font-bold
}
.mgc-Chevron {
    mask-image: url('/chevron-right.svg');
    background-color: var(--color-primary4);
    mask-size: 12px 12px;
    width: 12px;
    height: 12px;
}
.mgc-Chevron:hover {
    background-color: var(--color-primary4);
}
.star-icn{
    mask-image: url('/star.svg');
    background-color: var(--color-primary4);
    mask-size: 18px 18px;
    width: 18px;
    height: 18px;  
}
.slide-img{
    object-fit: fill;
    height: 100%;
    width: 100%;
}
.side-cont{
    position: relative;
    width: 100%;
    height: 250px;
    min-height: 250px;
    border: 1px solid var(--banner-border);
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 3px 10px #0006;
    margin-bottom: 30px;   
}
.carousel-img {
  width: 100%;
  height: 250px; 
  object-fit: cover;
  border-radius: 0.5rem;
}
.jpNavCard{
  height: 100px;
  width: 100%;
  max-width: 120px;
  justify-self: center;
  border-radius: 16px;
  background: var(--color-primary1);
  display: grid;
  place-items: center;
  gap: 2px;
  padding: 8px 6px;
  box-shadow:
    rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset,
    rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset,
    rgba(0, 0, 0, 0.10) 0px -79px 40px 0px inset,
    rgba(0, 0, 0, 0.06) 0px 2px 1px,
    rgba(0, 0, 0, 0.09) 0px 4px 2px,
    rgba(0, 0, 0, 0.09) 0px 8px 4px,
    rgba(0, 0, 0, 0.10) -16px -8px 4px -4px inset;
}

.jpNavCard__icon{
  width: 38px;
  object-fit: contain;
  filter: drop-shadow(0 10px 20px rgba(0,0,0,0.35));
}
.jpNavCard__label{
  font-weight: 900;
  font-size: 14px;
  color: rgba(255,255,255,0.92);
}
.casino-jackpot-tabs {
  @apply mx-3 mt-3 mb-2 p-2 rounded-2xl;
  background: linear-gradient(
    180deg,
    color-mix(in srgb, var(--color-primary1) 35%, transparent),
    color-mix(in srgb, var(--color-primary1) 15%, transparent)
  );
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.12),
    0 8px 30px rgba(0,0,0,0.35);
}

.casino-jackpot-tabs__list {
  @apply flex items-center justify-center gap-2 list-none m-0 p-0;
}

.casino-jackpot-tabs__pill {
  @apply flex items-center gap-2 px-4 py-2 rounded-xl cursor-pointer text-white/80 text-sm font-semibold transition-all duration-200;
  background: color-mix(in srgb, var(--color-primary1) 12%, transparent);
}

.casino-jackpot-tabs__pill:hover {
  background: color-mix(in srgb, var(--color-primary1) 22%, transparent);
}

.casino-jackpot-tabs__pill--active {
  background: linear-gradient(
    180deg,
    color-mix(in srgb, var(--color-primary1) 90%, white 5%),
    var(--color-primary1)
  );
  color: #fff;
  box-shadow:
    0 6px 18px rgba(0,0,0,0.45),
    inset 0 1px 0 rgba(255,255,255,0.25);
}

.casino-jackpot-tabs__pill--active span {
  font-weight: 700;
}
</style>